var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00195312,
    y: 0.5,
    width: 80.0058,
    height: 80,
    rx: 40,
    fill: "white",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7319 65.5C35.103 65.4492 30.7804 64.2923 26.7953 61.9386C22.005 59.1094 18.4954 55.1311 16.3326 50.0046C15.805 48.7539 15.4148 47.4339 15.0821 46.1153C14.7215 44.6866 15.5515 43.3735 16.9965 42.8568C18.2762 42.3993 19.8107 42.997 20.4525 44.2374C20.651 44.621 20.7758 45.0471 20.9009 45.4637C22.7172 51.5118 26.5568 55.7493 32.3586 58.1965C35.3066 59.4399 38.3894 59.8142 41.5777 59.493C45.7184 59.0759 49.3687 57.5302 52.4858 54.7959C55.9365 51.7689 58.1551 47.9786 58.8552 43.4342C59.9516 36.317 57.846 30.2675 52.4632 25.4162C50.3359 23.4989 47.8761 22.1846 45.134 21.3764C44.6642 21.2379 44.1781 21.0795 43.7705 20.8193C42.5057 20.0117 42.0723 18.5026 42.6641 17.1701C43.2325 15.8907 44.7008 15.2209 46.1469 15.6104C52.4471 17.3074 57.3343 20.9484 60.9405 26.3604C62.88 29.271 64.0963 32.4807 64.6478 35.9019C65.7018 42.4408 64.4171 48.5273 60.7696 54.0854C58.0094 58.2913 54.2828 61.3668 49.6999 63.3879C47.4334 64.3875 45.0411 65.0101 42.5708 65.2801C41.6278 65.3832 40.6784 65.4284 39.7319 65.5Z",
    fill: "#DBFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.aba6f4297b4a859f54b01cf1f5945888.svg";
export { ForwardRef as ReactComponent };